interface ThemeProps {
  name: string;
  sidebar: {
    fontColor: string;
    bgColor: string;
    minimalBgColor: string;
    minimalBgCollapsedColor: string;
    focusedColor: string;
    focusedBgColor: string;
    dividerColor: string;
  };
  user: {
    namefield: string;
  };
  colors: {
    primary: {
      bgColor: string;
      bgColor2: string;
      btnColor: string;
      iconColor: string;
      iconSelectedColor: string;
    };
    secondary: {
      bgColor: string;
      btnColor: string;
    };
    solid: {
      color: string;
    };
    skeletonColor: string;
    headingColor: string;
    fontColor: string;
    fontSubColor: string;
    fontColorInverted: string;
  };
}

const light: ThemeProps = {
  name: 'light',
  sidebar: {
    fontColor: '#334D6E',
    bgColor: '#FFFFFF',
    minimalBgColor: '#F5F6F8',
    minimalBgCollapsedColor: '#FCFCFC',
    focusedColor: '#F5F6F8',
    focusedBgColor: '#5100CE',
    dividerColor: 'rgba(194, 207, 224, 0.3)',
  },
  user: {
    namefield: 'rgba(194, 207, 224, 0.1)',
  },
  colors: {
    primary: {
      bgColor: '#F5F6F8',
      bgColor2: '#F5F6F8',
      btnColor: '#5100CE',
      iconColor: '#334D6E',
      iconSelectedColor: '#5100CE',
    },
    secondary: {
      bgColor: '#FFFFFF',
      btnColor: '#DADADA',
    },
    solid: {
      color: '#FFFFFF',
    },
    skeletonColor: '#EEEEEE',
    headingColor: '#334D6E',
    fontColor: '#334D6E',
    fontSubColor: '#334D6E',
    fontColorInverted: '#000000',
  },
};

const dark: ThemeProps = {
  name: 'dark',
  sidebar: {
    fontColor: '#B6B7B8',
    bgColor: '#000000',
    minimalBgColor: '#131313',
    minimalBgCollapsedColor: '#131313',
    focusedColor: '#FCFCFC',
    focusedBgColor: '#5100CE',
    dividerColor: '#4F4F4F',
  },
  user: {
    namefield: '#090909',
  },
  colors: {
    primary: {
      bgColor: '#131313',
      bgColor2: '#8100FF',
      btnColor: '#8100FF',
      iconColor: '#B6B7B8',
      iconSelectedColor: '#f5f6f8',
    },
    secondary: {
      bgColor: '#131313',
      btnColor: '#DADADA',
    },
    solid: {
      color: '#000000',
    },
    skeletonColor: '#4F4F4F',
    headingColor: '#B6B7B8',
    fontColor: '#B6B7B8',
    fontSubColor: '#B6B7B8',
    fontColorInverted: '#FFFFFF',
  },
};

interface Themes {
  [theme: string]: ThemeProps;
}

const themes: Themes = {
  light,
  dark,
};

export default themes;
